import PropTypes from "prop-types";
import styles from "./index.css";
import CategoryHeaderLinks from "../CategoryHeader/CategoryHeaderLinks/CategoryHeaderLinks";
import CategoryHeaderHero from "./CategoryHeaderHero";
import EarlyAccessBanner from "./EarlyAccessBanner";
import { CATEGORY_BANNER_ID } from "../constants";
import * as types from "../CategoryHeaderMedia/constants";
import { SMALL_VIEWPORT } from "../../state/modules/layout";

const hasImageForViewport = (category, viewportCategory) => {
  const mediaKey = viewportCategory === SMALL_VIEWPORT ? "app" : "web";
  const media = category.featuredHeader?.[mediaKey];

  return Boolean(media?.imageUrl);
};

export const CategoryHeader = ({
  hasHeaderLinks,
  category,
  mediaType,
  viewportCategory,
  isComingSoon,
  scrollFunction,
}) => {
  const hasImage = hasImageForViewport(category, viewportCategory);

  return (
    <section
      id={CATEGORY_BANNER_ID}
      className={styles.wrapper}
      aria-label={hasImage ? `category banner ${mediaType}` : "category banner"}
    >
      <div className={styles.contentWrapper}>
        {hasImage ? (
          <CategoryHeaderHero
            category={category}
            viewportCategory={viewportCategory}
            isComingSoon={isComingSoon}
            scrollFunction={scrollFunction}
          />
        ) : (
          <EarlyAccessBanner
            endDate={category.loyaltyBenefit.endDate}
            customerAccess={category.loyaltyBenefit.customerAccess}
          />
        )}
        {hasHeaderLinks && <CategoryHeaderLinks />}
      </div>
    </section>
  );
};

CategoryHeader.propTypes = {
  category: PropTypes.shape({
    headerBody: PropTypes.string,
    headerTitle: PropTypes.string,
    loyaltyBenefit: PropTypes.shape({
      customerAccess: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  mediaType: PropTypes.oneOf(Object.values(types)).isRequired,
  hasHeaderLinks: PropTypes.bool.isRequired,
  viewportCategory: PropTypes.string.isRequired,
  isComingSoon: PropTypes.bool.isRequired,
  scrollFunction: PropTypes.func.isRequired,
};

export default CategoryHeader;
